import {
  LeaseCompanyAllBranchRequest,
  LeaseCompanyBranchRequest,
  LeaseCompanyComponentRequest,
  LeaseCompanyContractRequest,
  LeaseCompanyCreateServiceOrder,
  LeaseCompanyCreateServiceOrderLine,
  LeaseCompanyCreateUserData,
  LeaseCompanyDeleteUserRequest,
  LeaseCompanyExistsRequest,
  LeaseCompanyFixedPrice,
  LeaseCompanyFixedPriceRequest,
  LeaseCompanyInvoiceSummaryRequest,
  LeaseCompanySearchForTyresRequest,
  LeaseCompanySearchRequest,
  LeaseCompanyServiceOrderLineDeleteRequest,
  LeaseCompanyServiceOrderLineRequest,
  LeaseCompanyServiceOrderLinesRequest,
  LeaseCompanyServiceOrderRequest,
  LeaseCompanyServiceOrderStatusesRequest,
  LeaseCompanySpecificTyreRequest,
  LeaseCompanyUpdateServiceOrderData,
  LeaseCompanyUpdateServiceOrderLine,
  LeaseCompanyUserRequest,
  LeaseCompanyUserUUIDRequest,
  LeaseCompanyUsersRequest,
  checkLeaseCompanyDefaultUserExists,
  checkLeaseCompanyServiceOrderExists,
  createLeaseCompanyServiceOrder,
  createLeaseCompanyServiceOrderLine,
  createLeaseCompanyUser,
  deleteLeaseCompanyServiceOrderLine,
  deleteLeaseCompanyUser,
  getAllLeaseCompanyBranchFormulas,
  getLeaseCompanyBranchFormulaByUser,
  getLeaseCompanyComponent,
  getLeaseCompanyContract,
  getLeaseCompanyDefaultUser,
  getLeaseCompanyFixedPrice,
  getLeaseCompanyInvoiceSummary,
  getLeaseCompanySearchForTyres,
  getLeaseCompanySearchResults,
  getLeaseCompanyServiceOrder,
  getLeaseCompanyServiceOrderLine,
  getLeaseCompanyServiceOrderLines,
  getLeaseCompanyServiceOrderStatuses,
  getLeaseCompanySpecificTyre,
  getLeaseCompanyUser,
  getLeaseCompanyUsers,
  publishLeaseCompanyServiceOrder,
  setLeaseCompanyDefaultUser,
  testLeaseCompanyUser,
  updateLeaseCompanyServiceOrder,
  updateLeaseCompanyServiceOrderLine,
  updateLeaseCompanyServiceOrderLineReference,
  updateLeaseCompanyUser
} from '@cbgms/api/modules/lease-company'
import { IPaginatedRequest } from '@cbgms/api'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'

export const getContract = (workorderUUID: string) =>
  createAsyncApiAction<LeaseCompanyContractRequest>('gms', getLeaseCompanyContract(workorderUUID))

export const getUsers = () => createAsyncApiAction<LeaseCompanyUsersRequest>('gms', getLeaseCompanyUsers())

export const createUser = (data: LeaseCompanyCreateUserData) =>
  createAsyncApiAction<LeaseCompanyUserUUIDRequest>('gms', createLeaseCompanyUser(data))

export const updateUser = (userUUID: string, data: LeaseCompanyCreateUserData) =>
  createAsyncApiAction<LeaseCompanyUserUUIDRequest>('gms', updateLeaseCompanyUser(userUUID, data))

export const getUser = (userUUID: string) => createAsyncApiAction<LeaseCompanyUserRequest>('gms', getLeaseCompanyUser(userUUID))

export const deleteUser = (userUUID: string) => createAsyncApiAction<LeaseCompanyDeleteUserRequest>('gms', deleteLeaseCompanyUser(userUUID))

export const testUser = (data: LeaseCompanyCreateUserData) => createAsyncApiAction<any>('gms', testLeaseCompanyUser(data))

export const getAllBranchFormulas = () => createAsyncApiAction<LeaseCompanyAllBranchRequest>('gms', getAllLeaseCompanyBranchFormulas())

export const getBranchFormulaByUser = (userUUID: string) =>
  createAsyncApiAction<LeaseCompanyBranchRequest>('gms', getLeaseCompanyBranchFormulaByUser(userUUID))

export const existDefaultUser = () => createAsyncApiAction<LeaseCompanyExistsRequest>('gms', checkLeaseCompanyDefaultUserExists())

export const getDefaultUser = () => createAsyncApiAction<LeaseCompanyUserRequest>('gms', getLeaseCompanyDefaultUser())

export const setDefaultUser = (userUUID: string) =>
  createAsyncApiAction<LeaseCompanyUserUUIDRequest>('gms', setLeaseCompanyDefaultUser(userUUID))

export const getSearch = (workorderUUID: string, params: IPaginatedRequest) =>
  createAsyncApiAction<LeaseCompanySearchRequest>('gms', getLeaseCompanySearchResults(workorderUUID, params))

export const getComponent = (workorderUUID: string, code: string) =>
  createAsyncApiAction<LeaseCompanyComponentRequest>('gms', getLeaseCompanyComponent(workorderUUID, code))

export const existServiceOrder = (workorderUUID: string) =>
  createAsyncApiAction<LeaseCompanyExistsRequest>('gms', checkLeaseCompanyServiceOrderExists(workorderUUID))

export const getServiceOrder = (workorderUUID: string) =>
  createAsyncApiAction<LeaseCompanyServiceOrderRequest>('gms', getLeaseCompanyServiceOrder(workorderUUID))

export const createServiceOrder = (workorderUUID: string, data: LeaseCompanyCreateServiceOrder) =>
  createAsyncApiAction<LeaseCompanyUserUUIDRequest>('gms', createLeaseCompanyServiceOrder(workorderUUID, data))

export const updateServiceOrder = (workorderUUID: string, data: LeaseCompanyUpdateServiceOrderData) =>
  createAsyncApiAction<LeaseCompanyServiceOrderRequest>('gms', updateLeaseCompanyServiceOrder(workorderUUID, data))

export const publishServiceOrder = (workorderUUID: string) =>
  createAsyncApiAction<LeaseCompanyServiceOrderRequest>('gms', publishLeaseCompanyServiceOrder(workorderUUID))

export const getServiceOrderLines = (workorderUUID: string) =>
  createAsyncApiAction<LeaseCompanyServiceOrderLinesRequest>('gms', getLeaseCompanyServiceOrderLines(workorderUUID))

export const createServiceOrderLine = (workorderUUID: string, data: LeaseCompanyCreateServiceOrderLine) =>
  createAsyncApiAction<LeaseCompanyUserUUIDRequest>('gms', createLeaseCompanyServiceOrderLine(workorderUUID, data))

export const updateServiceOrderLine = (workorderUUID: string, workorderLineUUID: string, data: LeaseCompanyUpdateServiceOrderLine) =>
  createAsyncApiAction<LeaseCompanyUserUUIDRequest>('gms', updateLeaseCompanyServiceOrderLine(workorderUUID, workorderLineUUID, data))

export const updateServiceOrderLineReference = (serviceOrderUUID: string, workorderLineUUID: string, data: { ReferenceUUID: string }) =>
  createAsyncApiAction<void>('gms', updateLeaseCompanyServiceOrderLineReference(serviceOrderUUID, workorderLineUUID, data))

export const getServiceOrderLine = (workorderUUID: string, workorderLineUUID: string) =>
  createAsyncApiAction<LeaseCompanyServiceOrderLineRequest>('gms', getLeaseCompanyServiceOrderLine(workorderUUID, workorderLineUUID))

export const deleteServiceOrderLine = (workorderUUID: string, workorderLineUUID: string) =>
  createAsyncApiAction<LeaseCompanyServiceOrderLineDeleteRequest>(
    'gms',
    deleteLeaseCompanyServiceOrderLine(workorderUUID, workorderLineUUID)
  )

export const getSearchForTyres = (workorderUUID: string, params: IPaginatedRequest) =>
  createAsyncApiAction<LeaseCompanySearchForTyresRequest>('gms', getLeaseCompanySearchForTyres(workorderUUID, params))

export const getSpecificTyre = (workorderUUID: string, id: string) =>
  createAsyncApiAction<LeaseCompanySpecificTyreRequest>('gms', getLeaseCompanySpecificTyre(workorderUUID, id))

export const getServiceOrderStatuses = () =>
  createAsyncApiAction<LeaseCompanyServiceOrderStatusesRequest>('gms', getLeaseCompanyServiceOrderStatuses())

export const getFixedPrice = (workorderUUID: string, Data: LeaseCompanyFixedPrice) =>
  createAsyncApiAction<LeaseCompanyFixedPriceRequest>('gms', getLeaseCompanyFixedPrice(workorderUUID, Data))

export const getInvoiceSummary = (workorderUUID: string) =>
  createAsyncApiAction<LeaseCompanyInvoiceSummaryRequest>('gms', getLeaseCompanyInvoiceSummary(workorderUUID))
